module.exports = __webpack_public_path__ + "static/media/settings.8d7b4e53.png";